import { render } from "./page-no-access.vue?vue&type=template&id=6ceb014a&scoped=true"
import script from "./page-no-access.vue?vue&type=script&lang=js"
export * from "./page-no-access.vue?vue&type=script&lang=js"

import "./page-no-access.vue?vue&type=style&index=0&id=6ceb014a&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ceb014a"],['__file',"src/components/notepad/pages/page-no-access.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ceb014a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ceb014a', __exports__)) {
    api.reload('6ceb014a', __exports__)
  }
  
  module.hot.accept("./page-no-access.vue?vue&type=template&id=6ceb014a&scoped=true", () => {
    api.rerender('6ceb014a', render)
  })

}


export default __exports__